import { Controller } from '@hotwired/stimulus';

/**
 * MoeFee Global VAT Controller
 *
 * Tiny broadcaster — when the architect changes the global TVA segmented in
 * the MoeFee edit form (`app/views/moe_fees/_edit_form.html.erb`), dispatches
 * a window-level `moe-fee-global-vat:changed` event so every line's
 * `moe_fee_assiette#globalVatChanged` listener can update its per-line
 * "TVA par défaut : X %" hint without a server round-trip.
 *
 * Mounted on the form's outer wrapper `<div data-controller="moe-fee-global-vat">`;
 * each `Ui::RadioSegmentedComponent` radio carries
 * `data-action="change->moe-fee-global-vat#dispatch"`.
 *
 * No targets, no values — pure relay.
 *
 * @example
 * <div data-controller="moe-fee-global-vat">
 *   <input type="radio" name="moe_fee[vat_rate]" value="20.0"
 *          data-action="change->moe-fee-global-vat#dispatch">
 *   <input type="radio" name="moe_fee[vat_rate]" value="10.0"
 *          data-action="change->moe-fee-global-vat#dispatch">
 * </div>
 */
export default class extends Controller {
  /**
   * Fires `moe-fee-global-vat:changed` with `{ rate: <Number> }` on the
   * controller's element (bubbling) so per-line `@window` listeners catch it.
   *
   * Note: this method shadows the base `Controller#dispatch`. We use the
   * raw `dispatchEvent` API rather than `super.dispatch(...)` to keep the
   * intent explicit and avoid any name-collision footgun if Stimulus ever
   * binds `dispatch` differently in a future major.
   */
  dispatch(event) {
    const rate = parseFloat(event.target.value);
    if (Number.isNaN(rate)) return;
    this.element.dispatchEvent(
      new CustomEvent('moe-fee-global-vat:changed', {
        detail: { rate },
        bubbles: true,
      })
    );
  }
}
